export default __webpack_public_path__ + "static/media/first.4dd2fbbd.svg";